export default {
  btn: {
    addWork: "業務追加",
    save: "保存",
    back: "戻る",
    delete: "削除",
  },
  unit: {
    trialMonths: "{value}ヶ月",
    trialBonus: "{value}円 / 月",
    completion: "{value}円 / 件",
  },
  searchForm: {
    workName: "業務名",
    taskName: "タスク",
    date: "業務有効日",
    taskStatus: "業務有効区分",
    callRequired: "架電の要否",
    search: "検索",
    btn: {
      back: "戻る",
      edit: "編集",
      cancel: "キャンセル",
      save: "保存",
    },
    taskStatusValue: {
      valid: "有効",
      invalid: "無効",
    },
    callRequiredValue: {
      valid: "必要",
      invalid: "不要",
    },
  },
  columns: {
    date: "業務有効日",
    workCode: "業務番号",
    workName: "業務名",
    taskName: "タスク",
    trialMonths: "トライアル期間",
    trialBonus: "トライアル手当",
    planType: "プラン",
    planTrialPaymentPerCompletion: "トライアル報酬",
    planPaymentPerCompletion: "報酬",
    callRequired: "架電の要否",
    departmentNameLevel4: "部門名（第4階層名）",
    departmentNameLevel5: "部門名（第5階層名）",
    departmentCode: "管理会計部門コード",
    startDate: "業務有効開始日",
    endDate: "業務無効日",
    taskStatus: "業務有効区分",
    memo: "メモ",
    action: "アクション",
  },
  numberManagement: {
    title: "管理番号",
    workCode: {
      label: "業務番号",
      placeholder: "業務番号を入力してください",
    },
  },
  workInformation: {
    title: "業務情報",
    workName: {
      label: "業務名",
      placeholder: "業務名を入力してください",
    },
    callRequired: {
      label: "架電の要否",
      required: "必要",
      notRequired: "不要",
    },
    hasPlanFlg: {
      label: "タスク",
      hasPlan: "プランあり",
      noPlan: "プランなし",
    },
    addBtn: "タスク追加",
  },
  taskInformation: {
    title: "タスク",
    mainInformation: {
      taskNumber: {
        label: "タスク番号",
      },
      taskType: {
        label: "タスク区分",
        edit: "件数",
        noEdit: "円",
      },
      taskName: {
        label: "タスク名",
        placeholder: "タスク名を入力してください",
      },
    },
    effectivePeriod: {
      workStartDate: {
        label: "業務有効開始日",
      },
      workEndDate: {
        label: "業務無効日",
      },
      taskStatus: {
        label: "タスク区分",
        valid: "有効",
        invalid: "無効",
      },
    },
    trialMonths: {
      trialFlg: {
        label: "トライアル手当",
        have: "あり",
        no: "なし",
      },
      trialMonths: {
        label: "トライアル期間",
        suffix: "月",
      },
      trialBonusThreshold: {
        label: "トライアル手当支給件数",
        suffix: "件毎に支給",
      },
      trialBonus: {
        label: "トライアル手当",
        suffix: "円 / 月",
      },
    },
    planInformation: {
      type: "プラン",
      completionFrom: {
        label: "件数",
        suffix: "件",
        maxValue: "上限なし",
      },
      trialPaymentPerCompletion: {
        label: "トライアル報酬",
        suffix: "円 / 件",
      },
      payment: {
        label: "報酬",
        suffix: "円 / 件",
      },
      btn: {
        add: "追加",
        remove: "削除",
      },
      upperLimitMustExceedLower: "件数の上限は件数の下限以上でなければなりません",
    },
  },
  departmentInformation: {
    title: "管理部門情報",
    departmentNameLevel4: {
      label: "部門名（第4階層名）",
      placeholder: "部門名（第4階層名）を入力してください",
    },
    departmentNameLevel5: {
      label: "部門名（第5階層名）",
      placeholder: "部門名（第5階層名）を入力してください",
    },
    departmentCode: {
      label: "管理会計部門コード",
      placeholder: "管理会計部門コードを入力してください",
    },
  },

  memo: {
    title: "メモ",
    placeholder: "メモを入力してください",
  },
  confirmDeleteDescription: "この業務を削除しますか？\n「本確定」以外の実績データも削除される可能性があります。",
  deleteWorkSuccess: "業務を削除しました。",
}
